export default __webpack_public_path__ + "static/media/TotemManual10.cc7bb8fa.jpg";